module.exports = __webpack_public_path__ + "static/media/corner_bg.68571b74.svg";